module.exports = __webpack_public_path__ + "ma.svg?a0d63aedd7aaf5fd59caf0d56a3d5fdf";